import React, { useState } from 'react'
import UserManagementTable from './Components/UserManagementTable'
import AddUsers from './Components/AddUsers'
import AppShell from '../../Components/AppShell'
import PageHeader from '../../Components/PageHeader'
import FloatBar from '../../Components/FloatBar'
import AppFooter from '../../Components/AppFooter'

const ManageUsersView = () => {
  const [isEditable, setIsEditable] = useState(false)
  const [updateTable, setUpdateTable] = useState(false)

  const updateIsEditable = (value) => {
    setIsEditable(value)
  }

  const toggleUpdateTable = () => {
    setUpdateTable((prevState) => !prevState)
  }

  // Preserve previous behavior: hide side rail while a row is being edited
  if (isEditable) {
    return (
      <div className="nx-app-bg flex min-h-screen w-full flex-col text-paper">
        <FloatBar />        <main className="flex min-h-0 flex-1 flex-col overflow-y-auto px-4 py-5 sm:px-6 lg:px-8">
          <PageHeader
            kicker="Admin"
            title="Users"
            subtitle="Create accounts and assign department permissions."
            crumbs={[
              { label: 'Home', to: '/home' },
              { label: 'Admin', to: '/adminNXS0011/dashboard' },
              { label: 'Users' },
            ]}
            actions={<AddUsers updateTable={toggleUpdateTable} />}
          />
          <UserManagementTable updateIsEditable={updateIsEditable} updateTable={updateTable} />
          <AppFooter className="mt-12" />
        </main>
      </div>
    )
  }

  return (
    <AppShell>
      <PageHeader
        kicker="Admin"
        title="Users"
        subtitle="Create accounts and assign department permissions."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Admin', to: '/adminNXS0011/dashboard' },
          { label: 'Users' },
        ]}
        actions={<AddUsers updateTable={toggleUpdateTable} />}
      />
      <UserManagementTable updateIsEditable={updateIsEditable} updateTable={updateTable} />
    </AppShell>
  )
}

export default ManageUsersView
